<template>
  <div class="tradedetailApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='3'></headComponent>
    <div class="h"></div>
    <div class="proBg" :style="'background: url('+baseUrl+setTradeDetail.images+') no-repeat center;'">
      <div class="at">{{setTradeDetail.title}}</div>
    </div>
    <div class="main">
      <div class="con" v-html="setTradeDetail.content"></div>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        proBg:require('../../../assets/images/probg.png'),
        setTradeDetail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$fileurl;
    },
    mounted() {
      this.beforeMount();
      this.getTradeDetail();
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getTradeDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/caseDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setTradeDetail = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .tradedetailApp .el-message-box{
    width:30%
  }
  .tradedetailApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .tradedetailApp .h{
    height:96px
  }
  .tradedetailApp .proBg{
    height: 39.06vw;
    color:#fff;
    font-size: 2vw;
    text-align:center;
    position: relative;
  }
  .tradedetailApp .proBg .at{
    position: absolute;
    width:100%;
    bottom: 2.708vw;
  }
  .tradedetailApp .main{
    max-width:1600px;
    margin:0 auto;
    background:#fff;
    font-size:16px;
    color: #333;
    padding: 30px 0
  }
  .tradedetailApp .main .title{
    text-align:center;
    font-size:22px;
    padding-bottom:25px;
    font-weight:bold
  }
  .tradedetailApp .main .con{
    width:90%;
    margin:0 auto
  }
  .tradedetailApp .main p {
    font-size: 16px;
    color: #333;
    letter-spacing: 1px;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom:15px
  }
  .tradedetailApp .main img {
    display: block;
    margin: 0 auto;
  }
  
  @media only screen and (max-width: 1199px) {
    .tradedetailApp .header,.tradedetailApp .h{
      height:60px;
    }
    .tradedetailApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .tradedetailApp .header .nav{
      text-align:right
    }
    .tradedetailApp .header .nav li{
      margin:0 1.8vw
    }
    .tradedetailApp .header .nav .close{
      display:none
    }
    .tradedetailApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .tradedetailApp .proBg{
      font-size:18px;
    }
    .tradedetailApp .main dl dd{
      width:50%
    }
  } 
</style>